import { Injectable } from "@angular/core";
import * as libphonenumber from "google-libphonenumber";
import { MobileNumberInputValueInterface } from "src/app/components/indigo-yellow-ui/interfaces/mobile-number-input-value.interface";

@Injectable({
  providedIn: "root",
})
export class PhoneValidationService {
  isValidNumber(inputNumber: MobileNumberInputValueInterface) {
    if (inputNumber) {
      // special override for Estonia to be able to accept sample numbers in https://github.com/SK-EID/MID/wiki/Test-number-for-automated-testing-in-DEMO
      if (inputNumber.countryCode == "EE") {
        const phoneLength = String(inputNumber.number)?.replace(/\s+/g, '')?.length;
        if (phoneLength >= 7 && phoneLength <= 8) {
          return true;
        }
      }

      const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
      let valid = false;
      try {
        valid = phoneUtil.isValidNumber(phoneUtil.parse(inputNumber.e164Number));
      } catch {}
      return valid;
    }
    return false;
  }
}
